import { getAxios } from '../axios';
import {
  ENDPOINT_CLIENT_EMAILS
} from '../../config/endpoints';
import {
  getTokenHeaders,
  errorCatch, getNotificationId,
} from '../helper';
import { Messages } from '../../config';
import { store } from '../../store/store';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';
import { displayNotification } from '../../store/actions/notification';

/**
 * Send an email to client user
 * @param {object} payload
 * @param {string} payload.template
 * @param {boolean} payload.test
 * @param {string} payload.firstName
 * @param {string} payload.email
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function sendEmailUser(payload) {
   return getAxios().post(
     ENDPOINT_CLIENT_EMAILS,
     payload,
     getTokenHeaders()
   )
     .then(response => {
       if (response && response.status === 204) {
         store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.SEND_EMAIL_USER_SUCCESS, payload.notification || null));

         return response;
       }

       return null
     })
     .catch(
       e => {
         errorCatch(e, {
           400: 'concat',
           401: Messages.UNAUTHENTICATED_ERROR,
           403: Messages.UNAUTHORIZED_ERROR,
           404: Messages.NOT_FOUND_ERROR,
         }, getNotificationId(payload));

         return e.response;
       }
     );
}
